// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-diferencial-curso.white{width:calc(45px + 1vw);height:calc(45px + 1vw);border-radius:80px 80px;border:2px solid #f9d428!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
